/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { PropsWithChildren, useEffect, useState } from 'react';
import styles from '../../styles/FormLayout.module.css';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';

interface Props {
  header?: string
  subHeader?: string
  button?: ReactJSXElement
  backButton?:ReactJSXElement
  disabled?:boolean;
  submitButtom?:ReactJSXElement;
  backLink?:ReactJSXElement;
}

export default function FormLayout({ header, subHeader, children, button,backButton, disabled,submitButtom,backLink }: PropsWithChildren<Props>) {
 
  const [isDisabled,setDisabled] = useState(disabled);

  
  const [disableAttr,setDisabledAttr] = useState('');

  function getSubmitButton(){
   
    if(button){
      return (
        <div>{button}</div>
      );
    } else if(submitButtom){
      return (<div>{submitButtom}</div>);
    } else{
      return (
        <div className={styles.bottom}><span className={styles.requiredLabel}>* Required field</span>
          <div>
            {/* {backButton} */}
      <button  id="submit_button" className={`accent-1 ${styles.submit}`}  type="submit"
       disabled={disabled}>Continue</button></div>
      </div>);
    }
  }

  function getBackButton(){
   
    if(backButton){
      console.log(backButton)
      return (
        <div>{backButton}</div>
      );
    }
  }

  function getBackLink(){
    if(backLink){
      console.log(backLink)
      return (
        <div>{backLink}</div>
      );
    }
  }

  return (
    <main className={styles.main}>
      <div>{getBackButton()}</div>
      <div className={styles.grid}>
      {/* <div>{getSubmitButton()}</div> */}
        <div className={styles.formGroup} >
          <div className={styles.headerGroup}>
          
            {header && <h4 className={`brand-voice ${styles.header}`} dangerouslySetInnerHTML={ {__html:header}}>
            </h4>}
            {header && subHeader && <div className={styles.subHeader} dangerouslySetInnerHTML={ {__html:subHeader}}>
            
            </div>}
          </div>
            {children && <div className={styles.center}  >
              {children}
            </div>}
        </div >
        <div>{getBackLink()}</div>
        {getSubmitButton()}
        
      </div>
    </main>
  );
};
